import { AsyncPipe } from "@angular/common";
import { AfterViewInit, Component, ElementRef, Inject, OnInit, Renderer2, ViewEncapsulation } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { InProgressAnimationComponent } from "../in-progress-animation/in-progress-animation.component";

var MarkdownIt = require("markdown-it"),
  md = new MarkdownIt();

@Component({
  selector: "app-terms-and-policy",
  templateUrl: "./terms-and-policy.component.html",
  styleUrls: ["./terms-and-policy.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [IonicModule, InProgressAnimationComponent, AsyncPipe, TranslatePipe]
})
export class TermsAndPolicyComponent implements OnInit, AfterViewInit {
  public intTermsAndPolicy: unknown;
  private unsubscribe$ = new Subject<void>();
  public userId: string;
  markUpContent$ = this.accountService.getWPContent(this.data.contentType).pipe(
    map((data: any) => {
      this.translate
        .get(["accountpage.about", "accountpage.Service", "accountpage.policy", "accountpage.Terms"])
        .subscribe((res: string) => {
          let h = [];
          h.push({
            about: res["accountpage.about"],
            Service: res["accountpage.Service"],
            policy: res["accountpage.policy"],
            Terms: res["accountpage.Terms"],
          });
          this.heading = h[0];
        }, err => { return (err) });
      this.title =
        this.data.contentType === "privacy_policy"
          ? this.heading.policy
          : this.data.contentType === "terms_and_conditions"
            ? this.heading.Terms
            : this.heading.about;
      return data?.replace(/\\u2013|\\u2018|\\u2019/g, '');

    })
  );

  contentType: any;
  contentResponse: any;
  decodedHtml: string;
  loaded: boolean;
  title: any;
  heading: any;

  constructor(
    private accountService: AccountRepositoryService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<TermsAndPolicyComponent>,
    private analytics: AngularFireAnalytics,
    private GTMSegment: GTMSegmentService,
    public translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.GTMSegment.GTMPopupInitialization(this.data.contentType);
    this.markUpContent$.pipe(takeUntil(this.unsubscribe$)).subscribe((data: Data) => {
      if (data) {

        this.authService.getDVFromString(data).then((dvString: string) => {
          if (dvString) {
            this.intTermsAndPolicy = dvString;
          } else {
            return ''
          }
        }).catch((err) => {
          return err
        });
      }
    })
  }

  async ngOnInit() {
    await this.authService.getUid("TermsAndPolicyComponent").then((uid) => {
      this.userId = uid;
    })
    this.analytics.logEvent("app_terms_and_policy", { userId: this.userId });

  }

  ngAfterViewInit(): void {
    // Setup event listeners after the component is initialized
    setTimeout(() => {
      this.setupEventListeners();
    }, 1700);
  }

  closeDialog() {
    this.bottomSheetRef.dismiss();
  }

  // This function is used to close the bottom sheet
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  // This function is used to close the bottom sheet
  private setupEventListeners() {
    try {
      // Get the native element using ElementRef
      const deleteInfoElement = this.elementRef.nativeElement.querySelector(".deleteInfo");
      // Add click event listener using Renderer2 if element exists
      if (deleteInfoElement) {
        this.renderer.listen(deleteInfoElement, "click", () => {
          this.bottomSheetRef.dismiss();
          this.router.navigate(["/close-your-account"]);
        });
      }
    } catch (error) {
      return error;
    }
  }


}
